import type { IncentiveProgram } from "../types";
import { IncentiveProgramEdit } from "./IncentiveProgramEdit";
import { IncentiveProgramList } from "./IncentiveProgramList";

/**
 * Almikia Epic E7 (TASK-095): "Incentivos", direccion-only (see
 * `IncentiveProgramList`/`IncentiveProgramEdit`'s own `CanAccess` gates).
 *
 * ASSUMPTIONS:
 * - No create page: a brand-new version of an existing program is drafted
 *   through "Nueva vigencia" (`NewVigenciaDialog`), never a blank create
 *   form -- the 5 program `code`s are fixed by the DATA CONTRACT, not
 *   invented by a direccion user.
 * - No delete action: an incentive program is never hard-deleted -- ending
 *   one means setting `valid_to` through "edit" (matches `canAccess.ts`'s
 *   `incentive_programs`/"delete" -> false).
 */
export default {
  list: IncentiveProgramList,
  edit: IncentiveProgramEdit,
  recordRepresentation: (record: IncentiveProgram) => record.name,
};
